import { styled } from '@mui/material';

export const Wrapper = styled('div')(({ theme }) => ({
  border: '1px solid #DFDDE5',
  margin: '15px 0',
  background: theme.palette.background.default,
  display: 'flex',
  alignItems: 'center',
  minHeight: '140px',
}));

export const ModalWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

export const ModalText = styled('p')({
  textAlign: 'center',
});

export const ModalBalanceWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 5),
  margin: theme.spacing(2.5, 0, 4, 0),
}));

export const ModalButtonWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
}));
